import { useEffect } from 'react';
import { listenVehiclesChanges } from '../../channels/tripVehiclesChangesChannel';
import { useTripVehiclesChangesStore } from '../../stores/useTripVehiclesChangesStore';

export function useTripVehiclesChangesChannel() {

    useEffect(() => {

        const unsubscribe = listenVehiclesChanges(({ tipo, payload }) => {

            const {
                setVehicleChangesBatch,
                upsertVehicleChange
            } = useTripVehiclesChangesStore.getState();

            if (tipo === 'trip-vehicle-changes') {

                setVehicleChangesBatch(payload, false);

            }

            if (tipo === 'trip-vehicle-changes-upsert') {

                upsertVehicleChange(payload, false);

            }

        });

        return unsubscribe;

    }, []);

}